import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';

export default function useGetTournamentStandings(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation(
    async ({
      round,
      tournamentId,
      limit,
      offset,
      search,
      userId,
    }: {
      round: number;
      tournamentId: string;
      limit: number;
      offset: number;
      search?: string;
      userId?: string | null;
    }) => {
      const params = new URLSearchParams({
        tournamentId,
        round: round.toString(),
        limit: limit.toString(),
        offset: offset.toString(),
      });

      if (search?.trim()) {
        params.append('search', search.trim());
      }

      if (userId) {
        params.append('userId', userId.toString());
      }

      const response = await TournamentRestClient.get(
        `/tournament/players-ranking?${params.toString()}`,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return mutation;
}
